import "core-js/stable";
import Vue from "vue";
import App from "./App";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import VueSlideBar from "vue-slide-bar";

import VueSvgGauge from "vue-svg-gauge";

import * as am4core from "@amcharts/amcharts4/core";
import DatePicker from "v-calendar/lib/v-calendar.umd";

import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import CircleIcon from "@/containers/CircleIcon.vue";
// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
require("font-awesome/css/font-awesome.css");
require("@/assets/flaticon/flaticon-custom.css");

Vue.use(PerfectScrollbar);

// am4core.useTheme(am4themes_animated);
am4core.options.autoDispose = true;
am4core.options.minPolylineStep = 5;

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(VueSvgGauge);
Vue.use(Viewer);

Vue.component("v-date-picker", DatePicker);
Vue.prototype.$log = console.log.bind(console);

Vue.component("VueSlideBar", VueSlideBar);

Vue.component("circle-icon", CircleIcon);

new Vue({
  el: "#app",
  router,
  store,
  icons,
  template: "<App/>",
  components: {
    App,
  },
});
